<template>
  <div class="c-matrix__row">
    <div class="c-matrix__spacer">{{ title }}</div>
    <div class="c-matrix__titles">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-matrix {
  &__row {
    display: grid;
    grid-template-columns: 2fr 1fr;
    border-bottom: 1px solid $colour-nhs-med-grey;
    margin-bottom: 5px;
    align-items: center;
  }

  &__spacer {
    font-weight: bold;
  }

  &__titles {
    display: flex;
    justify-content: space-evenly;
    padding: 10px;

    > * {
      align-self: center;
      flex-basis: 0;
      flex-grow: 1;
      text-align: center;
    }
  }
}
</style>
